import { render, staticRenderFns } from "./CompareSummary.vue?vue&type=template&id=2eacf67b&scoped=true&"
import script from "./CompareSummary.vue?vue&type=script&lang=js&"
export * from "./CompareSummary.vue?vue&type=script&lang=js&"
import style0 from "./CompareSummary.vue?vue&type=style&index=0&id=2eacf67b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eacf67b",
  null
  
)

export default component.exports